<template lang="html">
<div>
    <div class="content-i">
        <div class="content-box" v-if="accountsCount > 0">
            <div class="col-sm-12 col-md-6 offset-md-3 col-lg-6 offset-lg-3">
                <div class="element-wrapper">
                    <div class="element-box">
                        <h5 class="form-header">{{ t('associatedAccountsText', 'associatedAccountsText')}}</h5>
                        <div class="form-header">{{ t('associatedVatNumberAccountsList','associatedVatNumberAccountsList') }} <b>{{ getUserDetails.VAT_number }}</b> 
                            <br>
                            {{ t('selectAccountsToLinkText', 'selectAccountsToLinkText') }} <b>{{ getUserDetails.email }}</b>
                        </div>
                        <br />
                        <b-form v-on:submit.prevent="linkUserAccounts">
                            <b-form-group>
                                <b-form-checkbox-group v-model="selected_accounts">
                                    <b-form-checkbox :value="account" v-for="account in getMatchingAccounts">{{ account }}</b-form-checkbox>
                                </b-form-checkbox-group>
                            </b-form-group>
                            <div class="form-buttons-w"><button class="btn btn-primary">{{ t('applyButtonText','applyButtonText') }}</button></div>
                        </b-form>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="content-box">
            <div class="col-sm-12 col-md-6 offset-md-3 col-lg-6 offset-lg-3">
                <div class="element-wrapper">
                    <div class="element-box">
                        <p>There are no accounts to be linked</p>
                        <label><router-link :to="{ path: '/delivery_rules' }">{{ t('goToDeliveryRules', 'goToDeliveryRules') }}</router-link></label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import {i18n} from '@/plugins/i18n'

export default {
    name: 'link_accounts',
    data() {
        return {
            selected_accounts: []
        }
    },
    computed: {
        ...mapGetters(['allTemplateDetails','getUserDetails','getMatchingAccounts']),
        accountsCount() {
            return Object.keys(this.getMatchingAccounts).length
        }
    },
    methods: {
        changeBackgroud(){
            document.body.style.backgroundImage = "none"
        },
        linkUserAccounts() {
            this.$store.dispatch('linkUserAccounts', { customerRefs: this.selected_accounts })
        },
        getCurrentLang() {
            let loaded_languages = i18n.availableLocales
            let language = localStorage.getItem('currentTranslation') || 'EN'

            if(loaded_languages.indexOf(language) == -1) {
                this.$store.dispatch('getLangTranslation', {
                currentLang: language
                })
            }
        },
    },
    created() {
        this.changeBackgroud()
        this.getCurrentLang()
        // in case we reload the page, load the accounts again
        if(Object.keys(this.$store.state.mainAuth.matchingAccounts).length == 0 ) {
            this.$store.dispatch('requestMatchingAccounts')
        }
    }
}
</script>

<style>

</style>